import { Component, OnDestroy, OnInit, inject, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
// import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// import { resetUserFilters, updateUserFilters } from 'src/app/core/store/management/actions/user-filters.actions';
// import { selectUserFilterFilters } from 'src/app/core/store/management/reducers';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideRefreshCw } from '@ng-icons/lucide';
import { HlmIcon } from '../../../../ui/icon/src';
import { HlmButton } from '../../../../ui/button/src';
import { HlmTooltipImports } from '../../../../ui/tooltip/src';
import { HlmLabel } from '@spartan-ng/helm/label';
import { HlmCheckbox } from '@spartan-ng/helm/checkbox';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmSelectImports } from '@spartan-ng/helm/select';
import { UserRole } from '@core/models/users';
import { i18n } from '@shared/pipes/i18n.pipe';
import { RemapRolePipe } from '@shared/pipes/remap-role.pipe';

@Component({
  selector: 'app-user-props-component',
  styles: [':host { display: block; min-width: 350px}'],
  template: `
    <div class="p-6">
      <h3 class="text-lg font-semibold mb-4 text-center">Filters</h3>
      <form [formGroup]="propsGroup" class="mb-3">
      <div class="w-100 mb-3">
        <label hlmLabel>Roles</label>
        <brn-select [multiple]="true" formControlName="roles" class="w-full">
          <hlm-select-trigger>
            <hlm-select-value />
          </hlm-select-trigger>
          <hlm-select-content>
            @for (role of roles; track role) {
              <hlm-option [value]="role">{{ role | remapRole | i18n }}</hlm-option>
            }
          </hlm-select-content>
        </brn-select>
      </div>

      <section formGroupName="status" class="flex items-center gap-4">
        <label class="flex items-center gap-2 cursor-pointer">
          <hlm-checkbox formControlName="enabled" />
          <span class="text-sm select-none">Enabled</span>
        </label>
        <label class="flex items-center gap-2 cursor-pointer">
          <hlm-checkbox formControlName="disabled" />
          <span class="text-sm select-none">Disabled</span>
        </label>
      </section>
      </form>

      <div class="flex justify-center gap-3 mt-6">
        <button hlmBtn variant="ghost" size="icon" (click)="resetFilters()" hlmTooltip="Clear filters">
          <ng-icon hlm name="lucideRefreshCw" />
        </button>
        <button hlmBtn variant="outline" (click)="context.close()">Cancel</button>
        <button hlmBtn variant="outline" (click)="updateStore()">Confirm</button>
      </div>
    </div>
  `,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ...BrnSelectImports,
    ...HlmSelectImports,
    HlmLabel,
    HlmCheckbox,
    HlmButton,
    ...HlmTooltipImports,
    NgIcon,
    HlmIcon,
    RemapRolePipe,
    i18n,
  ],
  providers: [provideIcons({ lucideRefreshCw })],
})
export class UserPropsFilterDialogComponent implements OnInit, OnDestroy {
  private fb = inject(UntypedFormBuilder);
  readonly context = injectBrnDialogContext();

  propsGroup!: UntypedFormGroup;

  roles = Object.values(UserRole);

  dirty = output<boolean>();

  sub!: Subscription;

  ngOnInit(): void {
    this.propsGroup = this.fb.group({
      roles: [null],
      status: this.fb.group({
        enabled: [true],
        disabled: [false],
      }),
    });

    // this.store
    //   .select(selectUserFilterFilters)
    //   .pipe(
    //     take(1),
    //     tap(({ roles, tenants, status }) => {
    //       this.propsGroup.patchValue({
    //         roles,
    //         tenants,
    //         status,
    //       });
    //       this.dirty.emit(
    //         !this.enabled || this.disabled || (tenants && tenants.length > 0) || (roles && roles.length > 0)
    //       );
    //     })
    //   )
    //   .subscribe();
  }

  updateStore() {
    //this.store.dispatch(updateUserCurrentPage({pageIndex: 0, pageSize: 10, length: 0}));
    //this.store.dispatch(updateUserFilters(this.propsGroup.value));
    this.dirty.emit(
      !this.enabled ||
        this.disabled ||
        (this.propsGroup.value.tenants && this.propsGroup.value.tenants.length > 0) ||
        (this.propsGroup.value.roles && this.propsGroup.value.roles.length > 0)
    );
    this.context.close();
  }

  resetFilters() {
    this.propsGroup.reset({ status: { enabled: true } });
    //this.store.dispatch(resetUserFilters());
    this.dirty.emit(false);
  }

  get enabled() {
    return (this.propsGroup!.get('status') as UntypedFormGroup)!.get('enabled')!.value;
  }

  get disabled() {
    return (this.propsGroup!.get('status') as UntypedFormGroup)!.get('disabled')!.value;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
